<dx-popup class="popupSample"
          id="popupLimit"
          [width]="615"
          height="auto"
          [showTitle]="true"
          [showCloseButton]="true"
          title="Edit custom columns"
          [dragEnabled]="false"
          [hideOnOutsideClick]="false"
          (onHiding)="btnCancel_Click()"
          [(visible)]="__bVisible">
  <div *dxTemplate="let data of 'content'">

    <div class="row message-border">
      <div class="col-lg-12 col-md-12 col-xs-12 message-box">
        <div id="form-limit">
          <div class="col-lg-12 col-md-12 col-xs-12 padding0px">
            <div class="dx-field">
              <div class="dx-field-label">Counterparty: </div>
              <div class="dx-field-value padding-top-04rem">{{__oCounterpartyLimit.TradingCounterpartyName}}</div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">Our Entity: </div>
              <div class="dx-field-value padding-top-04rem">{{__oCounterpartyLimit.TradingEntityName}}</div>
            </div>
            <div class="dx-field">
              <div class="dx-field-label">Limit Type: </div>
              <div class="dx-field-value padding-top-04rem">
                {{__oCounterpartyLimit.LimitTypeName}}
                <span *ngIf="__oCounterpartyLimit.LimitTypeName === 'Volume'" class="buy-sell-span">(Buy-Sell)</span>
              </div>
            </div>
            <div *ngIf="__oCounterpartyLimit.LimitTypeName && __oCounterpartyLimit.LimitTypeName !== 'Volume'" class="dx-field">
              <div class="dx-field-label">Trading Category: </div>
              <div class="dx-field-value padding-top-04rem">{{__oCounterpartyLimit.TradingCategoryName}}</div>
            </div>
            <div *ngIf="__oCounterpartyLimit.LimitTypeName && __oCounterpartyLimit.LimitTypeName === 'Volume'" class="dx-field">
              <div class="dx-field-label">Trading Product: </div>
              <div class="dx-field-value padding-top-04rem">
                {{__oCounterpartyLimit.TradingProductName}}
              </div>
            </div>

            <div class="dx-field" *ngFor="let item of __oLimitCustomProperties">
              <div class="dx-field-label" title="{{item.LimitCustomProperty}}">{{item.LimitCustomProperty}}:</div>
              <div class="dx-field-value">
                
                <dx-text-box *ngIf="item.LimitCustomPropertyDataType == 'String'" [(value)]="item.Value" [placeholder]="item.LimitCustomProperty" >
                </dx-text-box>
                
                <dx-text-area *ngIf="item.LimitCustomPropertyDataType == 'MultiLineString'" [(value)]="item.Value" [height]="item.Height" [maxLength]="item.TextSize" [placeholder]="item.LimitCustomProperty" >                  
                </dx-text-area>
                
                <dx-select-box *ngIf="item.LimitCustomPropertyDataType == 'DropDown'" [(value)]="item.Value" [dataSource]="item.ItemSource" [searchEnabled]="true" >                   
                </dx-select-box>
                
                <app-date-picker *ngIf="item.LimitCustomPropertyDataType == 'Date'" [value]="item.Value" type="date" [placeholder]="__sPortalDateFormat" [displayFormat]="__sPortalDateFormat"
                     (onDatePickerValueChanged)="item.Value=$event.value">                 
                </app-date-picker>
                
                <dx-number-box *ngIf="item.LimitCustomPropertyDataType == 'Numeric' || item.LimitCustomPropertyDataType == 'Money'" 
                  [(value)]="item.Value"  
                  [format]="item.FormatString"
                  [ngClass]="{'negativeFontColor' : item.Value != null && item.Value != undefined && item.Value < 0 }" style="text-align:right;"
                  [min]="item.Min" [max]="item.Max"
                  (onKeyUp)="onKeyPressNumberBoxState($event,item.lLimitCustomPropertyId)">
                </dx-number-box>
                
                <dx-check-box *ngIf="item.LimitCustomPropertyDataType == 'True/False'" style="margin-top: 7px;" [(value)]="item.Value">
                </dx-check-box>
                
                <table style="width:100%;" *ngIf="item.LimitCustomPropertyDataType == 'Uri'">
                  <tr>
                    <td style="width:80%">
                      <dx-text-box [height]="30" [visible]="item.ReferenceDataTextBoxVisible" [placeholder]="item.LimitCustomProperty" [(value)]="item.Value" 
                        (onFocusOut)="ReferenceTextBoxLostFocus(item.lLimitCustomPropertyId)" (onChange)="ReferenceTextBoxLostFocus(item.lLimitCustomPropertyId)">
                      </dx-text-box>
                      <button (click)="OpenReferenceDataURL(item.lLimitCustomPropertyId)" style="word-break: break-word;" [ngStyle]="{'visibility':item.ReferenceDataURLVisible ? 'visible':'hidden'}"
                              class="downloadLink" title="{{item.Value}}" >
                        {{item.Value}}
                      </button>
                    </td>
                    <td style="vertical-align:top;">
                      <dx-button text="Copy" hint="Copy" (onClick)="copyMessage(item.Value)" class="btn-secondary btn_cpy"
                                  ></dx-button>
                     </td>
                    <td style="vertical-align:top;">
                      <dx-button text="Edit" hint="Edit" (onClick)="EditReferenceData(item.lLimitCustomPropertyId)"
                      class="btn-secondary btn_edt" ></dx-button>
                    </td>
                  </tr>
                </table>

              </div>
            </div>


          </div>

        </div>
      </div>
    </div>

    <div class="row" style="margin: 0px; ">
      <div class="col-lg-12 col-md-12 col-xs-12 btn-section">
        <div class="col-lg-9 col-md-9 col-xs-9 padding0px" style="float: right;">
          <dx-button id="btnPopUpCancel" (onClick)="btnCancel_Click()" text="Cancel"></dx-button>
          <dx-button id="btnOk" (onClick)="btnApply_Click(false)" text="Ok"></dx-button>
        </div>
      </div>
    </div>

  </div>
</dx-popup>
